import SideBarTool from '@/commons/components/side-bar-tool';
import './index.less';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as CheckSvg } from './icons/check.svg';
import { ReactComponent as OpenSvg } from './icons/open.svg';
import { ReactComponent as CloseSvg } from './icons/close.svg';
import { ReactComponent as EditSvg } from './icons/edit.svg';
import { ReactComponent as MoveSvg } from './icons/move.svg';
import { ReactComponent as DrawSvg } from './icons/draw.svg';
import { ReactComponent as RoamSvg } from './icons/roam.svg';
import classNames from 'classnames';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Input, InputNumber, Modal, Skeleton, Tooltip, message } from 'antd';
import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import genUUID from '@/commons/utils/gen-uuid';
import TnModal from '@/commons/widget/base-modal';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import { graphicStore } from '@/commons/store/graphic-store';
import { RoamRoute } from '@/commons/interface/building/roam-route';
import { createRoamRoutes, deleteRoamRoutes, findRoamRoutes, updateRoamRoutes } from '@/api/building/roam-route';
import { createPrimitiveMulti, deletePrimitivesInGraphic } from '@/api/geometry/primitive';
import { getSpecialPrimitiveLayerUuid } from '@/commons/utils/layer-utils';
import { LayerType } from '@/commons/enums/layer-type';
import { ARCHI_SUB_CONTROL } from '@/passets/archibase-engine/enums/archi-sub-control';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal';
import { RoamPointT } from '@/passets/archibase-engine/models/RoamPointT';
import axios from 'axios';
import { AmbientLight, BufferGeometry, CatmullRomCurve3, Line, LineBasicMaterial, Mesh, MeshBasicMaterial, MeshStandardMaterial, Quaternion, Vector3 } from 'three';
import { ModelBase, PointT } from 'pytha';
import { PYTHA_SINGAL } from '@/passets/pytha-engine/enums/pytha-signal';
import { CAMERA_TYPE } from '@/panel/graphic/draw/viewport';
import TnMessage from '@/commons/widget/message';
import { roamAnimate, roamByFixedRoute, roamCameraMove, roamCameraRotate, roamMove } from './tween';
import { DragModal } from 'tncet-common';
import { FieldTimeOutlined } from '@ant-design/icons';


interface IProps {

}

const rotationSpeed = 15; // 旋转速度
const transormTime = 120000; // 移动时间
const roamSplit = 1000; // 漫游曲线分割间隔
const moveSpeed = 100; // 移动速度

export default function RoamRoutePanel(props: IProps) {

    const { projectUuid, modelUuid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const systemContext = useContext<SystemStatus>(SystemContext);
    const [roamRoutes, setRoamRoutes] = useState<RoamRoute[]>([]);
    // 当前激活的路线
    const [activeRouteUuid, setActiveRouteUuid] = useState<string>('');
    // 是否在编辑时间
    const [editingTime, setEditingTime] = useState<boolean>(false);
    // 当前激活的路径点
    const [activePointUuid, setActivePointUuid] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    // const [adding, setAdding] = useState<boolean>(false);
    // const [addName, setAddName] = useState<string>('');
    const [editRoamRoute, setEditRoamRoute] = useState<RoamRoute>(null);
    // 编辑的漫游路径点
    const [editRoamPoint, setEditRoamPoint] = useState<any>(null);
    const [editName, setEditName] = useState<string>('');
    const [hoverRow, setHoverRow] = useState<RoamRoute>(null);

    const roamRouteRef = useRef(null);
    const tmpObjectUuidsRef = useRef(null);
    const activeRouteUuidRef = useRef(null);
    const roamRoutesRef = useRef(null);

    // 漫游所需的变量
    const activeAllPointsRef = useRef([]);    // 漫游曲线分割后的所有点
    const activeRoamIndexRef = useRef(0);   // 当前在漫游曲线中的索引
    const isRoamingRef = useRef(false);    // 是否在漫游中

    useEffect(() => {
        activeRouteUuidRef.current = activeRouteUuid;
        activeRoamIndexRef.current = 0;
    }, [activeRouteUuid])

    useEffect(() => {
        roamRoutesRef.current = roamRoutes;
    }, [roamRoutes])

    useEffect(() => {
        if (!projectUuid || !modelUuid) return;
        generateData();
    }, [projectUuid, modelUuid])

    useEffect(() => {
        return () => {
            clearPreviewLine();
        }
    }, [])

    useEffect(() => {
        // let editor = graphicStore.extraContext.getCurrentViewEditor();
        // if (!!editor) {
        //     editor.renderer.domElement.addEventListener('keydown', onKeyDown, true);  // 启用捕获阶段
        // } else {
        //     setTimeout(() => {
        //         let editor = graphicStore.extraContext.getCurrentViewEditor();
        //         editor.renderer.domElement.addEventListener('keydown', onKeyDown, true);  // 启用捕获阶段
        //     }, 3000)
        // }
        // return () => {
        //     if (!!editor) {
        //         editor.renderer.domElement.removeEventListener('keydown', onKeyDown);
        //     }s
        // }
    }, [graphicStore.extraContext])

    const onKeyDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!activeRouteUuidRef.current) return;
        if (e.key === 'w' || e.key === 's') {
            if (!activeAllPointsRef.current) return;
            let endIndex;
            if (e.key === 'w') {
                endIndex = activeRoamIndexRef.current + moveSpeed;
                endIndex = Math.min(endIndex, activeAllPointsRef.current.length - 1);
            } else {
                endIndex = activeRoamIndexRef.current - moveSpeed
                endIndex = Math.max(0, endIndex);
            }
            if (endIndex === activeRoamIndexRef.current || isRoamingRef.current) return;
            isRoamingRef.current = true;
            roamMove(transormTime / 3, activeAllPointsRef.current, activeRoamIndexRef.current, endIndex, () => {
                activeRoamIndexRef.current = endIndex;
                isRoamingRef.current = false;
            })
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown'
            || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            if (isRoamingRef.current) return;
            isRoamingRef.current = true;
            let vertical;
            let angle;
            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                vertical = false;
                angle = e.key === 'ArrowUp' ? rotationSpeed : -rotationSpeed;
            } else {
                vertical = true;
                angle = e.key === 'ArrowLeft' ? rotationSpeed : -rotationSpeed;
            }
            roamCameraRotate(angle, vertical);
            isRoamingRef.current = false;
        }
    }

    const clearPreviewLine = () => {
        // 从场景中删除预览路线
        if (roamRouteRef.current && roamRouteRef.current?.parent) {
            roamRouteRef.current.parent.remove(roamRouteRef.current);
            roamRouteRef.current = null;
        }
        if (tmpObjectUuidsRef.current) {
            graphicStore?.extraContext?.getCurrentViewEditor()?.removeObjectByUuids(tmpObjectUuidsRef.current);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners?.signals?.needRender?.dispatch('redraw');
        }
    }

    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // 绘制路线完成的信号
        graphicStore?.extraContext?.getCurrentViewEditor().listeners.getSignal(ARCHIBASE_SINGAL.drawRoamRouteFinish).add(onAddSave);
        // 特殊图元的变更（这里特指点的移动/删除）
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.add(onPointsDeleted);
        // 特殊图元的位置移动变更（move、夹点）
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).add(onPointsMove);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            graphicStore?.extraContext?.getCurrentViewEditor().listeners.getSignal(ARCHIBASE_SINGAL.drawRoamRouteFinish).remove(onAddSave);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.remove(onPointsDeleted);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).remove(onPointsMove);
        }
    }, [graphicStore?.extraContext, roamRoutes, projectUuid, modelUuid, activeRouteUuid])

    const generateData = () => {
        // 获取漫游路线
        setLoading(true);
        clearPreviewLine();
        setActiveRouteUuid(null);
        findRoamRoutes(projectUuid, modelUuid).then(res => {
            if (res.status === 200) {
                let data: RoamRoute[] = res.data || [];
                setRoamRoutes(data);
            }
        }).catch(err => {
            message.error("获取数据失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onDeleteClick = () => {
        if (!activeRouteUuid) {
            message.warning("未选中路线");
            return;
        }
        TnModal().deleteModal({
            onOk() {
                Modal.destroyAll();
                setLoading(true);
                // TODO 删除
                deleteRoamRoutes(activeRouteUuid).then(res => {
                    if (res.status === 200) {
                        let didx = roamRoutes?.findIndex(item => item.uuid === activeRouteUuid);
                        let thisRoute = roamRoutes[didx];
                        roamRoutes.splice(didx, 1);
                        setRoamRoutes([...roamRoutes]);
                        // TODO 删除这些图元
                        if (graphicStore?.extraContext?.getCurrentViewEditor() && thisRoute?.entities?.length > 0) {
                            graphicStore?.extraContext?.getCurrentViewEditor().removeObjectByUuids(thisRoute?.entities?.map(i => i?.uuid));
                            clearPreviewLine();
                        }
                        message.success("删除成功");
                    }
                }).catch(err => {
                    message.error("删除失败");
                }).finally(() => {
                    setLoading(false);
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            content: "点击确认，删除所选中路线",
            closable: true
        })
    }

    const onAddBtnClick = () => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        getSpecialPrimitiveLayerUuid(projectUuid, modelUuid, LayerType.ROAM_ROUTE_POINT).then(layerUuid => {
            message.info("开始绘制路线，请勿更改侧边栏");
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.DRAWROAMROUTECONTROL.name);
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(ARCHIBASE_SINGAL.drawRoamRoute).dispatch(null, layerUuid);
        })
    }

    const onAddSave = (roamRouteUuid: string, roamPointArr: RoamPointT[]) => {
        if (roamPointArr?.length < 1) return;
        if (!roamRouteUuid) {
            // 没有路线uuid，是添加
            let uuid = genUUID();
            let data = [];
            roamPointArr.forEach(item => {
                item.extraData = {
                    roamRouteUuid: uuid
                }
                data.push(item.toJson());
            })
            let roamRoute: RoamRoute = {
                uuid: uuid,
                projectUuid: projectUuid,
                modelUuid: modelUuid,
                name: `路线-${genUUID().slice(0, 8)}`,
                entities: data,
                roamTime: transormTime,
            }
            axios.all([
                createRoamRoutes(projectUuid, modelUuid, roamRoute)
            ]).then(res => {
                roamRoute.id = uuid;
                roamRoutes.push(roamRoute);
                setRoamRoutes([...roamRoutes]);
                changeActive(roamRoute);
                message.success("添加成功");
            }).catch(err => {
                message.error("添加失败");
            }).finally(() => {
                setLoading(false);
            })
        } else {
            // 有路线uuid，是新增
            let idx = roamRoutes?.findIndex(item => item.uuid === roamRouteUuid);
            let newRoamRoutes = roamRoutes[idx];
            let entities = roamPointArr?.map(item => item.toJson());
            newRoamRoutes.entities = entities;
            setRoamRoutes([...roamRoutes]);
            clearPreviewLine();
            changeActive(newRoamRoutes);
            updateRoamRoutes(roamRouteUuid, newRoamRoutes).then(res => {
                message.success("编辑成功");
            }).catch(err => {
                message.error("编辑失败");
            }).finally(() => {
                setLoading(false);
            })
        }

    }

    const onEditSave = (isEditTime: boolean = false) => {
        let newRoute = { ...editRoamRoute }
        if (!isEditTime) {
            if (!editName || editName?.trim()?.length === 0 || editName === editRoamRoute?.name) {
                setEditRoamRoute(null);
                setEditName("");
                return;
            }
            newRoute.name = editName;
        } else {
            if (newRoute.roamTime == null) {
                newRoute.roamTime = transormTime;
            }
            setEditingTime(false);
        }
        setLoading(true);
        updateRoamRoutes(editRoamRoute?.uuid, newRoute).then(res => {
            if (res.status === 200) {
                let idx = roamRoutes?.findIndex(item => item.uuid === editRoamRoute?.uuid);
                roamRoutes[idx] = newRoute;
                setRoamRoutes([...roamRoutes]);
                message.success("编辑成功");
                setEditRoamRoute(null);
                setEditName("");
            }
        }).catch(err => {
            message.error("编辑失败");
        }).finally(() => {
            setLoading(false);
        })

    }

    // 保存漫游路径点
    const onEditPointSave = () => {
        if (!editName || editName?.trim()?.length === 0 || editName === editRoamRoute?.name) {
            setEditRoamRoute(null);
            setEditName("");
            TnMessage.error("漫游路径名称不能为空")
            return;
        }
        let newPoint = {
            ...editRoamPoint,
            keyLabel: editName,
        }
        let activeRoute = roamRoutes.find(r => r.uuid === activeRouteUuid);
        let activePointIndex = activeRoute?.entities?.findIndex(p => p.uuid === editRoamPoint?.uuid);
        activeRoute.entities[activePointIndex] = newPoint;
        setLoading(true);
        updateRoamRoutes(activeRoute.uuid, activeRoute).then(res => {
            TnMessage.success("编辑成功");
        }).catch(err => {
            TnMessage.error("编辑失败");
            activeRoute.entities[activePointIndex] = editRoamPoint;
        }).finally(() => {
            setLoading(false);
            setEditName('');
            setEditRoamPoint(null);
        })
    }

    // 设置为关键点
    const setKeyPoint = (roam: RoamRoute, point: any) => {
        let origin = point.isKeyPoint
        point.isKeyPoint = !origin || false;
        setLoading(true);
        updateRoamRoutes(roam.uuid, roam).then(res => {
            TnMessage.success("设置成功");
        }).catch(err => {
            point.isKeyPoint = origin;
            TnMessage.error("设置失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeActive = (roamRoute: RoamRoute) => {
        if (!roamRoute) return;
        clearPreviewLine();
        setActiveRouteUuid(roamRoute?.uuid);
        activeRouteUuidRef.current = roamRoute?.uuid;
        setActivePointUuid(null);

        if (roamRoute?.entities?.length === 0) return;
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // 绘图区显示漫游路径
        let points = [];
        let addEntities = [];
        roamRoute?.entities?.forEach(item => {
            let entity = new RoamPointT();
            entity.fromJson(item);
            points.push(new Vector3(item.position.x, item.position.y, item.position.z));
            addEntities.push(entity);
        })
        const curve = new CatmullRomCurve3(points);
        activeAllPointsRef.current = curve.getPoints(roamSplit);

        const geometry = new BufferGeometry().setFromPoints(activeAllPointsRef.current);
        const material = new LineBasicMaterial({ color: 0x072983 });
        const curveObject = new Line(geometry, material);
        graphicStore.extraContext.sceneContext.scene.add(curveObject);
        graphicStore?.extraContext?.getCurrentViewEditor().addObjects(addEntities);
        roamRouteRef.current = curveObject;
        tmpObjectUuidsRef.current = addEntities?.map(item => item.uuid);

        let startPoint = roamRoute?.entities?.find(p => p?.isKeyPoint);
        if (startPoint == null) return;
        setActivePoint(startPoint);
    }

    /**
     * 改变激活的点
     * @param point 
     * @param roam 是否需要漫游，不漫游则直接修改相机位置
     * @returns 
     */
    const setActivePoint = (point: any, roam: boolean = false) => {
        let activeRoute = roamRoutes.find(r => r.uuid === activeRouteUuidRef.current);
        if (!roam) {
            roamCameraMove(point, activeRoute);
        } else {
            let closeDistance = Number.MAX_VALUE;
            const pointPos = new Vector3(point.position.x, point.position.y, point.position.z);
            let closeIndex = 0; // 最接近point的索引
            for (let index = 0; index < activeAllPointsRef.current.length; index++) {
                const splitPoint = activeAllPointsRef.current[index];
                const splitDistance = splitPoint.distanceTo(pointPos);
                if (splitDistance < closeDistance) {
                    closeDistance = splitDistance;
                    closeIndex = index;
                }
            }
            if (closeIndex === activeRoamIndexRef.current || isRoamingRef.current) return;
            isRoamingRef.current = true;
            roamMove(activeRoute?.roamTime || transormTime, activeAllPointsRef.current, activeRoamIndexRef.current, closeIndex, () => {
                activeRoamIndexRef.current = closeIndex;
                isRoamingRef.current = false;
            });
        }
        setActivePointUuid(point.uuid);
    }

    // 绘制路线
    const drawRoamRoute = (roamRoute: RoamRoute) => {
        if (!roamRoute?.uuid) return;
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        clearPreviewLine();
        getSpecialPrimitiveLayerUuid(projectUuid, modelUuid, LayerType.ROAM_ROUTE_POINT).then(layerUuid => {
            message.info("重新绘制路线，请勿更改侧边栏");
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.DRAWROAMROUTECONTROL.name);
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(ARCHIBASE_SINGAL.drawRoamRoute).dispatch(roamRoute.uuid, layerUuid);
        })
    }

    const onPointsDeleted = (modifyEntities: ModelBase[], isDelete: boolean) => {
        let roamPointEntities = modifyEntities?.filter(item => item.type === 'RoamPointT') || [];
        if (roamPointEntities?.length > 0) {
            if (isDelete) {
                // 1、路线上若干点被删除
                // 2、获取当前的路线，删除这两个点
                // 3、重新绘制路线
                let idx = roamRoutes?.findIndex(item => item.uuid === activeRouteUuid);
                let activeRoute = roamRoutes[idx];
                let newEntities = activeRoute?.entities?.filter(item => !modifyEntities?.some(me => me.uuid === item.uuid)) || [];
                activeRoute.entities = newEntities;
                setRoamRoutes([...roamRoutes]);
                clearPreviewLine();
                changeActive(activeRoute);
                updateRoamRoutes(activeRouteUuid, activeRoute).then(res => {
                    message.success("")
                })
            }
        }
    }

    const onPointsMove = (moveEntities: ModelBase[]) => {
        let roamPointEntities = moveEntities?.filter(item => item.type === 'RoamPointT') || [];
        let activeRoute = roamRoutesRef.current?.find(item => item.uuid === activeRouteUuidRef.current);
        roamPointEntities.forEach(item => {
            let idx = activeRoute?.entities?.findIndex(p => p.uuid === item.uuid);
            if (idx !== -1) {
                activeRoute.entities[idx] = item;
            }
        })
        setLoading(true);
        updateRoamRoutes(activeRouteUuid, activeRoute).then(res => {
            TnMessage.success("移动成功");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onRoamRoute = (e, roamRoute: RoamRoute) => {
        if (roamRoute.uuid !== activeRouteUuid) {
            changeActive(roamRoute);
        }
        let points = [];
        roamRoute?.entities?.forEach(item => {
            points.push(new Vector3(item.position.x, item.position.y, item.position.z));
        })
        const curve = new CatmullRomCurve3(points);
        isRoamingRef.current = true;
        roamByFixedRoute(curve, roamRoute?.roamTime || transormTime, () => {
            isRoamingRef.current = false;
            activeRoamIndexRef.current = roamSplit - 1;
            setActivePointUuid(roamRoute.entities[roamRoute.entities.length - 1].uuid);
        })
        roamAnimate();
    }

    return (
        <div className='side-bar-main'>
            <SideBarTool
                activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                onDeleteBtnClick={onDeleteClick}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="body">
                <div className="title">
                    路线
                </div>
                <Skeleton loading={loading} active>
                    <div className='roam-route-list'>
                        {roamRoutes?.map((item, key) => (
                            <>
                                <div className={classNames({
                                    'roam-route-row': true,
                                    'roam-route-row-active': activeRouteUuid === item?.uuid,
                                })}
                                    key={key}
                                    onMouseEnter={() => setHoverRow(item)}
                                    onMouseLeave={() => setHoverRow(null)}
                                >
                                    {(editRoamRoute?.uuid !== item?.uuid || editingTime) && <>
                                        <div className="file-name" onClick={() => changeActive(item)}>{item?.name || ''}</div>
                                        {hoverRow?.uuid === item?.uuid && <div className="edit-icon" onClick={() => {
                                            setEditRoamRoute(item);
                                            setEditName(item?.name);
                                        }}><Tooltip title="编辑路线名称" arrow={false}><EditSvg /></Tooltip></div>}
                                        {hoverRow?.uuid === item?.uuid && <div className="edit-icon" onClick={() => {
                                            setEditRoamRoute(item);
                                            setEditingTime(true);
                                        }}><Tooltip title="编辑路线漫游时间" arrow={false}><FieldTimeOutlined /></Tooltip></div>}
                                        {hoverRow?.uuid === item?.uuid && <div className="edit-icon" onClick={() => { drawRoamRoute(item) }}>
                                            <Tooltip title="重新绘制漫游路线" arrow={false}><DrawSvg /></Tooltip>
                                        </div>}
                                        {item?.entities?.length > 0 && hoverRow?.uuid === item?.uuid &&
                                            <div className="edit-icon" onClick={(e) => onRoamRoute(e, item)}>
                                                <Tooltip title="漫游路线" arrow={false}><RoamSvg /></Tooltip>
                                            </div>}
                                    </>}
                                    {editRoamRoute?.uuid === item?.uuid && !editingTime && <>
                                        <Input
                                            value={editName}
                                            onChange={(e) => setEditName(e.target.value)}
                                            onPressEnter={() => onEditSave()}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    setEditRoamRoute(null);
                                                    setEditName("");
                                                }
                                            }}
                                            onBlur={() => onEditSave()}
                                            placeholder='输入路线名称'
                                            autoFocus
                                        />
                                    </>}
                                </div>
                                {activeRouteUuid === item?.uuid &&
                                    <div className='point-list'>
                                        {item?.entities?.map(point => {
                                            return <div className={classNames({
                                                'point-row': true,
                                                'point-row-active': activePointUuid === point.uuid
                                            })}>
                                                {editRoamPoint?.uuid !== point?.uuid && <>
                                                    <div className="point-name" onClick={() => setActivePoint(point)}>{point?.keyLabel || ''}</div>
                                                    <div className="point-edit-icon" onClick={() => {
                                                        setEditRoamPoint(point);
                                                        setEditName(point?.keyLabel);
                                                    }}><Tooltip title="编辑路线点名称" arrow={false}><EditSvg /></Tooltip></div>
                                                    {/* <div className="point-edit-icon" onClick={() => setKeyPoint(item, point)}><DrawSvg /></div> */}
                                                    {/* {point?.isKeyPoint && <div className="point-edit-icon" onClick={(e) => {
                                                        e.stopPropagation();
                                                        setActivePoint(point, true);
                                                    }}><RoamSvg /></div>} */}
                                                </>}
                                                {editRoamPoint?.uuid === point?.uuid && <>
                                                    <Input
                                                        value={editName}
                                                        onChange={(e) => setEditName(e.target.value)}
                                                        onPressEnter={onEditPointSave}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Escape') {
                                                                setEditRoamPoint(null);
                                                                setEditName("");
                                                            }
                                                        }}
                                                        onBlur={onEditPointSave}
                                                        placeholder='输入漫游路线点名称'
                                                        autoFocus
                                                    />
                                                </>}
                                            </div>
                                        })}
                                    </div>}
                            </>
                        ))}
                    </div>

                    <DragModal
                        title="漫游路线时间管理"
                        visible={editingTime}
                        width={200}
                        mask
                        destroyOnClose
                        onClose={() => {
                            setEditRoamRoute(null);
                            setEditingTime(false);
                        }}>
                        <div className='roam-route-time-modal'>
                            <div className='roam-route-time-modal-body'>
                                <InputNumber min={1000} defaultValue={editRoamRoute?.roamTime || transormTime} onChange={(value) => {
                                    setEditRoamRoute({
                                        ...editRoamRoute,
                                        roamTime: value
                                    })
                                }} />
                            </div>
                            <div className='roam-route-time-modal-footer'>
                                <div
                                    className={classNames({
                                        'create-btn': true,
                                        'create-btn-active': false,
                                    })}
                                    onClick={() => onEditSave(true)}
                                >确定</div>
                            </div>
                        </div>
                    </DragModal>

                </Skeleton>
            </div>
        </div>
    )
}